import { fetchConToken, fetchUrl } from '../utils/fetch.ts';

export const obtener = async () => {
  try {
    const resp = await fetchConToken("parametros/obtener", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const actualizar = async (nombre: string, valor: string) => {
  try {
    const resp = await fetchConToken("parametros/actualizar", { nombre, valor }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

/**
 * Obtiene el valor del dólar desde la tabla dolar_historico del backend
 */
export const obtenerDolarHistorico = async () => {
  try {
    const resp = await fetchConToken("parametros/dolar", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const valorDolar = async () => {
  try {
    const resp = await fetchUrl("https://mindicador.cl/api/dolar", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export default { obtener, actualizar };





